import Nav from './Navigation'
import SubNavigation from './SubNavigation';

export default function Header(props) {

  return (
    <>
      <header className="header">
        <Nav />
        <SubNavigation toggleLang={props.toggleLang} lang={props.lang} connectClick={ props.connectClick } />
      </header>
    </>
  );
}

